const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const buildUrl = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  return `${API_BASE_URL}${path}${query.toString() ? `?${query}` : ""}`;
};

const requestJson = async (path, options = {}) => {
  const response = await fetch(path, options);
  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.success === false) {
    throw new Error(payload?.message || payload?.error || `HTTP ${response.status}`);
  }
  return payload;
};

const postJson = (path, payload, { signal } = {}) =>
  requestJson(buildUrl(path), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

export const CAKE_BRANCHES = Object.freeze({
  ALL: { code: "ALL", label: "Tất cả" },
  DONG_TIEN: { code: "DONG_TIEN", label: "Đồng Tiến" },
  BONPAS: { code: "BONPAS", label: "Bonpas" },
});

// Phạm vi cửa hàng cũ của các API bánh kem hiện hữu: chỉ Đồng Tiến.
export const DONG_TIEN_CAKE_STORE_IDS = Object.freeze([
  77, 58, 65, 60, 25, 80, 79, 73, 55, 37, 46, 16, 76, 62, 42, 83, 15,
  47, 39, 51, 69, 67, 68, 75, 66, 90, 74, 78, 41, 59, 105, 108, 112, 116,
  117, 118, 119, 120, 122, 128, 123, 124, 127, 129, 131, 132, 133, 136,
  137, 138, 139, 140, 141, 142, 144, 145, 147, 148, 149, 150, 156, 157,
  158, 160, 162, 1000, 1001, 164, 22, 63, 24, 56, 43, 53, 111, 48, 17,
  84, 36, 27, 57, 50, 70, 64, 71, 61, 31, 72, 32, 54,
]);

export const fetchCakeKpis = ({ branch, date, signal } = {}) =>
  requestJson(buildUrl("/api/cake-kpi/configurations", { branch, date }), {
    signal,
  });

export const saveCakeKpi = (payload) =>
  requestJson(buildUrl("/api/cake-kpi/configurations"), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

export const deleteCakeKpi = (configurationId) =>
  requestJson(
    buildUrl(`/api/cake-kpi/configurations/${configurationId}`),
    { method: "DELETE" }
  );

export const fetchBonpasCakeDailySales = ({ startDate, endDate, signal } = {}) =>
  requestJson(
    buildUrl("/api/bonpas-cake-daily-sales", { startDate, endDate }),
    { signal }
  );

export const fetchBonpasCakeSummary = ({ startDate, endDate, signal } = {}) =>
  requestJson(
    buildUrl("/api/bonpas-cake-summary", { startDate, endDate }),
    { signal }
  );

export const fetchCakeRetailSummary = (payload, options) =>
  postJson("/api/cake-retail-summary", payload, options);

export const fetchCakeOrderSummary = (payload, options) =>
  postJson("/api/cake-wholesale-summary", payload, options);

export const fetchCakeDailySales = (payload, options) =>
  postJson("/api/cake-daily-sales", payload, options);

export const fetchLargeCakeTopStores = (payload, options) =>
  postJson("/api/large-cake-top-stores", payload, options);

export const fetchCakeCategorySales = (payload, options) =>
  postJson("/api/cake-category-sales", payload, options);

export const fetchCakeInventory = ({ signal } = {}) =>
  requestJson(buildUrl("/api/cake-inventory"), { signal });

export const fetchCakeProduction = ({ startDate, endDate, signal } = {}) =>
  requestJson(
    buildUrl("/api/production-quantity", { startDate, endDate }),
    { signal }
  );

export const unwrapCakeKpiRows = (payload) =>
  Array.isArray(payload?.data) ? payload.data : [];
